'use strict';
import isUndefined from 'lodash/isUndefined';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {DatePicker} from '../../../core-components/android-date-time-pickers/components/DatePicker';
import {I18nComponent} from '../../../core-utilities/react-i18n/I18nComponent';
import {
  ExportModalFormatSelector,
  ExportModalHOCView,
  formatHeaderLabel,
} from '../../../core-utilities/redux-observable-list-exports/components/ExportModalHOC';

export function BaseTimerExportView(props) {
  const useNative = isUndefined(props.forceNativeDates) ? void 0 : props.forceNativeDates;
  return (
    <ExportModalHOCView
      className={props.className}
      targetData={props.targetData}
      format={props.format}
      status={props.status}
      headerLabel={props.headerLabel}

      onReset={props.onReset}
      onDownload={props.onDownload}
      onClose={props.onClose}
      onSubmit={props.onSubmit}
    >
      <div className="TimerExport__heading">
        <span className="item item-divider view-divider">
          {props.subHeaderLabel}
        </span>
        <span className="TimerExport__typeName">
          {props.targetData.name}
        </span>
        {!props.targetData.parentType ? null : (
          <span className="item item-divider view-divider">
            {props.parentLabel}
          </span>
        )}
        {!props.targetData.parentType ? null : (
          <span className="TimerExport__parentName">
            {props.targetData.parentName}
          </span>
        )}
      </div>

      <div className="full-padding-container form-response">

        <div className="item item-divider view-divider">
          {props.formatHeaderLabel}
        </div>
        <ExportModalFormatSelector
          format={props.format}
          onChangeFormatXlsx={props.onChangeFormatXlsx}
          onChangeFormatCsv={props.onChangeFormatCsv}
        />

        <div className="item item-divider view-divider">
          {props.dateRangeLabel}
        </div>
        <div className="TimerExport__splitPanel">
          <ul className="list filter-flex">
            <li
              className={classNames('item item-checkbox filter-half-item', {
                'filter-selected': props.filterOptions.dateRange.useAfter,
              })}
            >
              <label
                htmlFor="TimerExport_useAfter"
                className="checkbox filter-check filter-square-check"
              >
                <input
                  id="TimerExport_useAfter"
                  type="checkbox"
                  value={props.filterOptions.dateRange.useAfter}
                  onChange={props.onChangeUseAfter}
                />
              </label>
              <span>
                {props.dateAfterLabel}
              </span>
            </li>

            <li className="list task-schedule-header filter-half-item">
              <DatePicker
                className={classNames('dateinput', {
                  'click-disabled': !props.filterOptions.dateRange.useAfter,
                })}
                value={props.filterOptions.dateRange.afterDate}
                onChange={props.onChangeAfterDate}
                useNative={useNative}
              />
            </li>
          </ul>

          <ul className="list filter-flex">
            <li
              className={classNames('item item-checkbox filter-half-item', {
                'filter-selected': props.filterOptions.dateRange.useBefore,
              })}
            >
              <label
                htmlFor="TimerExport_useBefore"
                className="checkbox filter-check filter-square-check"
              >
                <input
                  id="TimerExport_useBefore"
                  type="checkbox"
                  value={props.filterOptions.dateRange.useBefore}
                  onChange={props.onChangeUseBefore}
                />
              </label>
              <span>
                {props.dateBeforeLabel}
              </span>
            </li>

            <li className="list task-schedule-header filter-half-item">
              <DatePicker
                className={classNames('dateinput', {
                  'click-disabled': !props.filterOptions.dateRange.useBefore,
                })}
                value={props.filterOptions.dateRange.beforeDate}
                onChange={props.onChangeBeforeDate}
                useNative={useNative}
              />
            </li>
          </ul>
        </div>
      </div>
    </ExportModalHOCView>
  );
}

BaseTimerExportView.propTypes = {
  /** @type {TimerExportState~TargetData} */
  targetData: T.object.isRequired,
  format: T.string.isRequired,
  filterOptions: T.shape({
    dateRange: T.object.isRequired,
  }),

  onChangeFormatXlsx: T.func,
  onChangeFormatCsv: T.func,
  onChangeUseAfter: T.func,
  onChangeAfterDate: T.func,
  onChangeUseBefore: T.func,
  onChangeBeforeDate: T.func,
  onReset: T.func,
  onDownload: T.func,
  onClose: T.func,
  onSubmit: T.func,

  showSuccess: T.bool,

  subHeaderLabel: T.string,
  parentLabel: T.string,
  formatHeaderLabel: T.string,
  formatXlsxLabel: T.string,
  formatCsvLabel: T.string,
  dateRangeLabel: T.string,
  dateBeforeLabel: T.string,
  dateAfterLabel: T.string,
  downloadButtonLabel: T.string,
  resetButtonLabel: T.string,
  closeButtonLabel: T.string,

  // testing
  forceNativeDates: T.bool,
};

export const TimerExportView = I18nComponent(BaseTimerExportView, [
  formatHeaderLabel,
  {code: 'timers.export.header.label', prop: 'headerLabel'},
  {code: 'timers.export.subheader.label', prop: 'subHeaderLabel', params: getSubHeaderParams},
  {code: 'timers.export.parent.label', prop: 'parentLabel', params: getParentParams},
  {code: 'tasks.filters.date.subheader.label', prop: 'dateRangeLabel'},
  {code: 'tasks.filters.date.before.label', prop: 'dateBeforeLabel'},
  {code: 'tasks.filters.date.after.label', prop: 'dateAfterLabel'},
]);

function getSubHeaderParams(props) {
  return {
    typeName: props.targetData.typeName,
  };
}

function getParentParams(props) {
  return {
    parentType: props.targetData.parentType,
  };
}



// WEBPACK FOOTER //
// ./src/js/timers/components/TimerExport/TimerExportView.js